import { useFetch } from "../lib/useData";
import { PageHero, Section, Placeholder } from "../components/public/PublicLayout";

const HERO = "https://images.unsplash.com/photo-1594385366598-a97b77392443?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function SocialService() {
  const { data: items } = useFetch("/public/social-service");
  return (
    <div>
      <PageHero title="Social Service & Gau Seva" subtitle="Seva to society in the spirit of devotion" image={HERO} />
      <Section className="space-y-16">
        {(items || []).map((it, idx) => (
          <div key={it.id} className={`grid md:grid-cols-2 gap-10 items-center ${idx % 2 ? "md:[&>*:first-child]:order-2" : ""}`} data-testid={`social-${it.slug}`}>
            <img src={it.image} alt={it.title} className="rounded-3xl shadow-xl w-full h-[360px] object-cover" />
            <div>
              <h2 className="font-display text-3xl font-bold text-stone-900">{it.title}</h2>
              <p className="text-lg text-stone-600 mt-4 leading-relaxed whitespace-pre-line">{it.description}</p>
              {it.gallery?.length > 0 && (
                <div className="flex gap-3 mt-6">
                  {it.gallery.slice(0, 3).map((g, i) => <img key={i} src={g} alt="" className="w-24 h-24 rounded-xl object-cover" />)}
                </div>
              )}
            </div>
          </div>
        ))}
        {(items || []).length === 0 && <p className="text-stone-500">Social service initiatives will be published soon.</p>}
      </Section>
    </div>
  );
}
